<div class="lum-c-bom-create-button">
  <button
    type="button"
    class="lum-button"
    mat-button
    [routerLink]="['/bom/create']"
  >
    <lum-ui-icon
      [cssClasses]="'mr-2-5'"
      icon="add-circle"
      color="#ffffff"
      width="20"
      height="20"
    ></lum-ui-icon>
    Create Bill of Materials
  </button>
</div>
